var FundamentalTabPeriodicityType = {
    FundamentalsAnnual : 1,
    FundamentalsQuarterly : 2,
    FundamentalsSemiAnnual : 3
}  

export default FundamentalTabPeriodicityType;